import { render } from "./RequestsHome.vue?vue&type=template&id=77445142&scoped=true"
import script from "./RequestsHome.vue?vue&type=script&lang=js"
export * from "./RequestsHome.vue?vue&type=script&lang=js"

import "./RequestsHome.vue?vue&type=style&index=0&id=77445142&scoped=true&lang=scss"

import exportComponent from "/Users/berkuralcan/Documents/dev/webdev/dansuk-engineering-dashboard-v3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77445142"]])

export default __exports__